import { useCallback } from 'react'
import { Box, Button, Grid, Paper, Typography } from '@aura/components'
import { withStyles } from '@aura/components/styles'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import RegistrationContainer from '../../../../components/new-registration-container'
import styles from './styles'


const Component = ({
    classes,
    onNext
}) => {

    const { t: translate, i18n } = useTranslation()

    const title = translate('forgotPwd')

    const footerContent = (
        <Grid className={classes.buttonContainer}>
            <Button
                className={classes.button}
                color='primary'
                onClick={useCallback(() => onNext())}>
                {translate('next')}
            </Button>
        </Grid>
    )

    const mainContent = (
        <Box className={classes.content}>
            <Box className={classes.contentInner}>
                {/* Subtitle and Warning Message */}
                <Box className={classes.textSection}>
                    <Typography className={classes.subtitle}>
                        {translate('forgotPwdFlow.subtitle')}
                    </Typography>
                    <Typography className={classes.warningMessage}>
                        {translate('forgotPwdFlow.warningMessage')}
                    </Typography>
                </Box>

                {/* Step Cards */}
                <Grid container className={classes.stepsContainer}>
                    <Paper className={classes.stepCard}>
                        <Box className={classes.stepContent}>
                            <Box className={classes.stepHeader}>
                                <Box className={classes.stepNumber}>1</Box>
                            </Box>
                            <Typography className={classes.stepTitle}>
                                {translate('forgotPwdFlow.step1Title')}
                            </Typography>
                            <Typography className={classes.stepDescription}>
                                {translate('forgotPwdFlow.step1Description')}
                            </Typography>
                        </Box>
                    </Paper>

                    <Box className={classes.stepDivider} />

                    <Paper className={classes.stepCard}>
                        <Box className={classes.stepContent}>
                            <Box className={classes.stepHeader}>
                                <Box className={classes.stepNumber}>2</Box>
                            </Box>
                            <Typography className={classes.stepTitle}>
                                {translate('forgotPwdFlow.step2Title')}
                            </Typography>
                            <Typography className={classes.stepDescription}>
                                {translate('forgotPwdFlow.step2Description')}
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>

                {/* Help Text */}
                <Typography className={classes.helpText}>
                    {translate('forgotPwdFlow.helpText')}
                </Typography>
            </Box>
        </Box>
    )

    return (<RegistrationContainer {...{ footerActions : footerContent,mainContent, title }}>        
    </RegistrationContainer>)
}

Component.displayName = 'Welcome'


Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        buttonContainer: PropTypes.object
    }),
    onNext: PropTypes.func.isRequired
}

export default withStyles(Component, styles)
